import { useMutation } from '@tanstack/react-query'
import { getAllUsers } from '../services'

export const useGetAllUsers = () => {
  return useMutation({
    mutationFn: (token: string) => getAllUsers(token),
  })
}
